<script lang="ts" setup>
  import type { Region } from '~/core/types/regions'

  type Props = {
    region: Partial<Region> & {
      thumb: string
      description: string
    }
  }
  const props = defineProps<Props>()

  const { t } = useI18n()

</script>
<template>
  <NuxtLink
    :to="`/region/${region.id}-${region.slug}`"
    class="c-region-card card"
  >
    <div
      class="picture"
      :style="{ 'background-image': `url(${props.region.thumb})` }"
    />
    <div class="content">
      <p class="label">
        <span>{{ region.name }}</span>
      </p>
      <p
        v-if="region.golfs_count"
        class="golfs"
      >
        <span>{{ region.golfs_count }} {{ t("common.golf", region.golfs_count) }}</span>
      </p>
    </div>
  </NuxtLink>
</template>
<style scoped>

.c-region-card {
  position: relative;
  z-index: 0;
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;

  .picture {
    position: relative;
    flex: 0 0 auto;
    border-radius: 4px;
    aspect-ratio: 4 / 3;
    background-color: var(--color-secondary);
    background-position: center;
    background-size: cover;
  }

  .content {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.625em 0.875em;
    border-radius: 0 0 4px 4px;
    background: white;

    .label {
      padding: 0.75em 0 0.125em;

      span {
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 1.375em;
        font-weight: 700;
      }
    }

    .golfs {
      padding: 0.125em 0 0.75em;

      span {
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 1em;
        font-weight: 600;
        opacity: 0.8;
      }
    }
  }

  @media screen and (width >= 1024px) {
    .content {
      .label {
        span {
          font-size: 1.125em;
        }
      }

      .golfs {
        span {
          font-size: 0.875em;
        }
      }
    }
  }

  @media screen and (width >= 1600px) {
    .content {
      .label {
        span {
          font-size: 1.375em;
        }
      }

      .golfs {
        span {
          font-size: 1em;
        }
      }
    }
  }
}
</style>
